import { render, staticRenderFns } from "./UserConfirmation.vue?vue&type=template&id=7c7516fc&"
import script from "./UserConfirmation.vue?vue&type=script&lang=js&"
export * from "./UserConfirmation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports